/* ============================================================
   Chizelclub cart engine
   - AJAX add-to-cart: no redirect, soft "pop" + button pulse,
     live bag-count bump, toast confirmation.
   - Slide-in cart drawer with +/- steppers and remove.
   - Also powers the full /cart page steppers + remove.
   Depends on nothing external. Vanilla JS.
   ============================================================ */
(function () {
  'use strict';

  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';

  function fmt(paise) {
    var v = paise / 100;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: CURRENCY, minimumFractionDigits: 2
      }).format(v);
    } catch (e) {
      return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }

  /* ---- soft pop via WebAudio (no asset needed) ---- */
  var actx = null;
  function pop() {
    try {
      actx = actx || new (window.AudioContext || window.webkitAudioContext)();
      if (actx.state === 'suspended') actx.resume();
      var t = actx.currentTime;
      var o = actx.createOscillator(), g = actx.createGain();
      o.connect(g); g.connect(actx.destination);
      o.type = 'sine';
      o.frequency.setValueAtTime(440, t);
      o.frequency.exponentialRampToValueAtTime(150, t + 0.13);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.3, t + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.17);
      o.start(t); o.stop(t + 0.18);
    } catch (e) {}
  }

  /* ---- cart count everywhere ---- */
  function setCount(n) {
    document.querySelectorAll('[data-cc-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    // little bump animation on the header badge
    var badge = document.querySelector('.cc-header__cart-count');
    if (badge) {
      badge.classList.remove('cc-bump');
      void badge.offsetWidth;
      badge.classList.add('cc-bump');
    }
  }

  /* ---- toast ---- */
  var toastTimer = null;
  function toast(msg, isErr) {
    var t = document.querySelector('[data-cc-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.toggle('is-error', !!isErr);
    t.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-open'); }, 2600);
  }

  /* ---- drawer open/close ---- */
  function drawer() { return document.querySelector('[data-cc-cart-drawer]'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    render();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cc-cd-lock');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cc-cd-lock');
  }

  /* ---- render drawer body from /cart.js ---- */
  function lineItemHTML(item, idx) {
    var img = item.image
      ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')
      : '';
    return '' +
      '<div class="cc-cd__item" data-key="' + item.key + '">' +
        '<a class="cc-cd__thumb" href="' + item.url + '">' +
          (img ? '<img src="' + img + '" alt="" width="70" height="93" loading="lazy">' : '') +
        '</a>' +
        '<div class="cc-cd__meta">' +
          '<a class="cc-cd__name" href="' + item.url + '">' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="cc-cd__variant">' + item.variant_title + '</span>' : '') +
          '<div class="cc-cd__row">' +
            '<div class="cc-cd__stepper" data-key="' + item.key + '">' +
              '<button type="button" class="cc-cd__step" data-step="-1" aria-label="Decrease">&minus;</button>' +
              '<span class="cc-cd__qty">' + item.quantity + '</span>' +
              '<button type="button" class="cc-cd__step" data-step="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cc-cd__price">' + fmt(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cc-cd__remove" data-remove="' + item.key + '" aria-label="Remove">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>';
  }

  function render() {
    var body = document.querySelector('[data-cc-cd-body]');
    var foot = document.querySelector('[data-cc-cd-foot]');
    if (!body) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (cart.item_count === 0) {
          body.innerHTML =
            '<div class="cc-cd__empty">' +
              '<span class="cc-cd__stitch" aria-hidden="true"></span>' +
              '<p>Your bag is empty.</p>' +
              '<a href="/collections/all-denim" class="cc-cd__shop" data-cc-cd-close>Shop denim</a>' +
            '</div>';
          if (foot) foot.hidden = true;
          return;
        }
        body.innerHTML = cart.items.map(lineItemHTML).join('');
        if (foot) {
          foot.hidden = false;
          var sub = foot.querySelector('[data-cc-cd-subtotal]');
          if (sub) sub.textContent = fmt(cart.total_price);
        }
      });
  }

  /* ---- change a line by key ---- */
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---- add to cart (intercept product form) ---- */
  function handleAdd(form) {
    var btn = form.querySelector('[type="submit"], [data-atc-label]');
    // require a variant id
    var idField = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"][type="hidden"]') || form.querySelector('[name="id"]');
    if (!idField || !idField.value) {
      var sizes = form.querySelector('.cc-pdp__size-row');
      if (sizes) { sizes.classList.remove('cc-shake'); void sizes.offsetWidth; sizes.classList.add('cc-shake'); }
      toast('Pick a size first', true);
      return;
    }
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        pop();
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.remove('cc-pulse'); void btn.offsetWidth; btn.classList.add('cc-pulse');
        }
        toast('Added to bag');
        render();            // refresh drawer contents in the background
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        toast((err && err.description) || 'Could not add to bag', true);
      });
  }

  /* ============ wire it up ============ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    handleAdd(form);
  });

  document.addEventListener('click', function (e) {
    // open drawer from any cart trigger
    var cartLink = e.target.closest('.cc-header__cart, [data-cc-cart-open]');
    if (cartLink) { e.preventDefault(); openDrawer(); return; }

    // close drawer
    if (e.target.closest('[data-cc-cd-close]')) { e.preventDefault(); closeDrawer(); return; }

    // stepper +/- inside drawer
    var step = e.target.closest('.cc-cd__step');
    if (step) {
      var wrap = step.closest('.cc-cd__stepper');
      var key = wrap.getAttribute('data-key');
      var qtyEl = wrap.querySelector('.cc-cd__qty');
      var next = Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(step.getAttribute('data-step'), 10));
      change(key, next).then(function () { render(); });
      return;
    }

    // remove inside drawer
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      change(rm.getAttribute('data-remove'), 0).then(function () { render(); });
      return;
    }

    // ---- full /cart page steppers + remove (shared) ----
    var pStep = e.target.closest('[data-cart-step]');
    if (pStep) {
      var row = pStep.closest('[data-cart-line]');
      var input = row.querySelector('[data-cart-qty]');
      var v = Math.max(0, parseInt(input.value, 10) + parseInt(pStep.getAttribute('data-cart-step'), 10));
      change(row.getAttribute('data-cart-line'), v).then(function () { window.location.reload(); });
      return;
    }
    var pRm = e.target.closest('[data-cart-remove]');
    if (pRm) {
      e.preventDefault();
      change(pRm.getAttribute('data-cart-remove'), 0).then(function () { window.location.reload(); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
